import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import SectionTitle from '../project-manage/SectionTitle';
import Question from '../project-manage/Question';

export default function QuestionsDeclined(props) {
  const { project, onViewMessages } = props;

  const questions = useConnect('question.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          response: 'Decline'
        }
      }
    },
    pagination: {
      pageSize: 100
    }
  });

  if (questions.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (questions.data.length === 0) {
    return null;
  }

  return (
    <SectionTitle
      title="Declined Partners"
      subtitle="These partners were unable to participate in the project."
    >
      <div className="grid grid-cols-1 gap-4">
        {questions.data.map(function (question, index) {
          return (
            <Question
              key={question.id || question.cid}
              question={question}
              onViewMessages={onViewMessages}
            />
          );
        })}
      </div>
    </SectionTitle>
  );
};
